const DEFAULT_REPLENISH_PERCENT = 100;

export { DEFAULT_REPLENISH_PERCENT };
